/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState } from 'react';
import toast from 'lib/toast';
import UpdatePrimaryDistrictId from './mutations/UpdatePrimaryDistrictId';
import GetPrimaryDistrictId from './queries/GetPrimaryDistrictId';
import usePrimaryDistrictId from './usePrimaryDistrictId';
import useCachedQuery from 'lib/useCachedQuery';
import * as I from 'immutable';
import { useMutation } from '@apollo/react-hooks';
import cx from 'classnames';

function useUpdatePrimaryDistrictId() {
  const primaryDistrictId = usePrimaryDistrictId();
  const companyId = useCompanyId();
  const opts = {
    refetchQueries: [{ query: GetPrimaryDistrictId }],
  };
  const [saveCompany] = useMutation(UpdatePrimaryDistrictId, opts);

  return function toggleAreaDefault(id: ID) {
    let newId = id;
    if (id === primaryDistrictId) {
      newId = null;
    }
    return saveCompany({
      variables: { id: companyId, primaryDistrictId: newId },
    });
  };
}

function useCompanyId() {
  const { data, errors } = useCachedQuery(GetPrimaryDistrictId);
  if (errors) {
    console.error(errors);
  }
  return I.getIn(data, ['me', 'company', 'id']);
}

function SavePrimaryAreaIdButton({ id }: { id: ID }): Element<string> {
  const primaryDistrictId = usePrimaryDistrictId();
  const isAreaDefault = String(primaryDistrictId) === String(id);
  const toggleAreaDefault = useUpdatePrimaryDistrictId();
  const [isDefaultDistrictSaving, setDefaultLoading] = useState(false);

  function onToggleDefault() {
    setDefaultLoading(true);
    toggleAreaDefault(id).then((res) => {
      const isSuccess = I.fromJS(res).getIn([
        'data',
        'companyUpdate',
        'success',
      ]);
      if (isSuccess) {
        toast('Default area changed');
      }
      setTimeout(() => {
        setDefaultLoading(false);
      }, 100);
    });
  }

  return (
    <button
      className="btn-link text-right btn-block"
      disabled={isDefaultDistrictSaving}
      onClick={() => {
        if (isDefaultDistrictSaving) return;
        onToggleDefault();
      }}
      data-testid="SavePrimaryAreaIdButton"
    >
      <i
        className={cx({
          'far fa-square': !isAreaDefault,
          'far fa-check-square': isAreaDefault,
        })}
      />{' '}
      {isDefaultDistrictSaving ? 'Saving..' : 'Set as Default Area'}
    </button>
  );
}

export default SavePrimaryAreaIdButton;
